/**
 * КРИТИЧНО: Защита от session fixation
 */
export function regenerateSessionId(): void {
  // После login всегда генерировать новый session ID
  const oldToken = localStorage.getItem('accessToken');
  if (oldToken) {
    // Очистить старый token
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  }
}

/**
 * КРИТИЧНО: Session timeout
 * @returns Cleanup функция для удаления event listeners
 */
export function setupSessionTimeout(): () => void {
  let timeoutId: NodeJS.Timeout;
  const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 минут

  const resetTimeout = () => {
    clearTimeout(timeoutId);

    // 30 минут неактивности = logout
    timeoutId = setTimeout(() => {
      // Используем более подходящее уведомление вместо alert
      const event = new CustomEvent('session-timeout', {
        detail: { message: 'Сессия истекла из-за неактивности' }
      });
      window.dispatchEvent(event);
      
      logout();
    }, SESSION_TIMEOUT_MS);
  };

  // Reset timeout при любой активности
  const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'] as const;
  events.forEach((event) => {
    document.addEventListener(event, resetTimeout, true);
  });

  resetTimeout();

  // Cleanup функция для удаления event listeners
  return () => {
    clearTimeout(timeoutId);
    events.forEach((event) => {
      document.removeEventListener(event, resetTimeout, true);
    });
  };
}

/**
 * КРИТИЧНО: Детект multiple tabs/windows
 * @returns Cleanup функция для удаления event listeners
 */
export function setupMultiTabDetection(): () => void {
  const handleStorageChange = (e: StorageEvent) => {
    if (e.key === 'accessToken' && !e.newValue) {
      // Token удален в другой вкладке
      window.location.href = '/login';
    }
  };

  // Если пользователь logout в одной вкладке, logout везде
  window.addEventListener('storage', handleStorageChange);

  // Cleanup функция для удаления event listener
  return () => {
    window.removeEventListener('storage', handleStorageChange);
  };
}

function logout() {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/login';
}

